<template>
  <div>
    <v-dialog v-model="show" max-width="550px" persistent>
      <v-card>
        <v-card-title class="text-h5 dialog-title">
          {{ title }}
        </v-card-title>
        <v-card-text>
          <template v-if="$slots.default"> <!-- priority to slot  -->
            <slot></slot>
          </template>
          <template v-else-if="text">
            {{ text }}
          </template>
          <template v-else-if="!hideText">
            Are you sure you want to continue?
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="showCancelButton"
            color="primary"
            text
            @click="cancel"
          >
            {{ cancelButtonText }}
          </v-btn>
          <v-btn
            v-if="showConfirmButton"
            :color="confirmButtonColor === 'red' ? 'red darken-1' : 'green'"
            text
            :loading="confirmButtonLoading"
            :disabled="confirmButtonLoading"
            @click="confirm"
          >
            {{ confirmButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ConfirmPopup',
  data: () => ({
    show: true,
  }),
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    text: {
      type: String,
      default: null
    },
    hideText: {
      type: Boolean,
      default: false
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: 'No'
    },
    confirmButtonText: {
      type: String,
      default: 'Yes'
    },
    confirmButtonColor: {
      type: String,
      default: 'green' // green or red
    },
    confirmButtonLoading: {
      type: Boolean,
      default: false
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>